import React from 'react'
import { InputBase, styled } from '@mui/material'

export const Root = styled('div')`
  display: inline-flex;
  flex-direction: column;
  font-family: ${props => props.theme.typography.fontFamily};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  width: ${props => props.width || '100%'};
`

export const Label = styled('label')`
  color: ${props => props.theme.palette.gray[50]};
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1.1px;
  line-height: 14px;
  margin: 0 0 0.3rem;
  text-transform: uppercase;
`

export const Counter = styled('label')`
  color: ${props => props.theme.palette.gray[50]};
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
`

export const Details = styled('div')`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin: 3px 0 0;
`

export const Required = styled(({ ...props }) => <span {...props}>*</span>)`
  color: ${props => props.theme.palette.gray[50]};
  font-size: 1rem;
`

export const BaseInput = styled(({ textAlign, ...props }) => <InputBase {...props} />)`
  background-clip: padding-box;
  background-color: ${props => props.theme.palette.brand.white};
  border: 1px solid ${props => props.theme.palette.gray[75]};
  border-radius: 0.25rem;
  box-sizing: border-box;
  color: ${props => props.theme.palette.gray[20]};
  display: flex;
  font-size: 1rem;
  height: auto;
  line-height: 1.5;
  overflow: hidden;
  -webkit-transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;

  & input,
  & textarea {
    box-sizing: border-box;
    flex-grow: 1;
    height: 100%;
    padding: 0.375rem 0.75rem;
    text-align: ${props => props.textAlign};
    width: auto;

    &::placeholder {
      color: ${props => props.theme.palette.gray[50]};
      font-family: ${props => props.theme.typography.fontFamily};
      font-size: 1rem;
      line-height: 1.5;
      opacity: 0.42;
      transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }
  }

  & input {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.Mui-focused {
    box-shadow: 0 0 0 0.2rem ${props => props.theme.palette.blue[50.25]};
  }

  &.Mui-disabled {
    background-color: ${props => props.theme.palette.gray[95]};
    border: 1px solid ${props => props.theme.palette.gray[75]};
    color: ${props => props.theme.palette.gray[50]};
    cursor: not-allowed;
  }

  &.Mui-disabled input {
    cursor: not-allowed;
  }

  &.Mui-error {
    border: 1px solid ${props => props.theme.palette.red[50]};
  }

  &.Mui-error.Mui-focused {
    box-shadow: 0 0 0 0.2rem ${props => props.theme.palette.red[50.5]};
  }
`

export const BottomMessage = styled('section')`
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 12px;
  line-height: 14px;
  min-height: 20px;
`

export const Info = styled('section')`
  color: ${props => props.theme.palette.gray[50]};
  font-style: italic;
`

export const Error = styled('section')`
  color: ${props => props.theme.palette.red[50]};
`

export const Prefix = styled('div')`
  align-items: center;
  background-color: ${props => props.theme.palette.gray[50]};
  display: flex;
  height: 100%;
  justify-content: center;
  width: 54px;
`

export const Suffix = styled('div')`
  align-items: center;
  background-color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 40px;
`
